<template>
  <div v-if="topics.length > 0" class="topic-view-related-topics-wrapper">
    <h3 class="title">相关专题</h3>
    <swiper :options="swiperOptions">
      <swiper-slide v-for="item in topics" :key="item.id">
        <TopicItem :item="item"></TopicItem>
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev">
        <i class="iconfont icon-zuocefanhuijiantou"></i>
      </div>
      <div slot="button-next" class="swiper-button-next">
        <i class="iconfont icon-youcefanhuijiantou"></i>
      </div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import TopicItem from '@/components/topic/TopicItem'
import { THIRD_API } from '@/global/config'

export default {
  components: {
    swiper,
    swiperSlide,
    TopicItem
  },
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      topics: [],
      swiperOptions: {
        freeMode: true,
        spaceBetween: 24,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    this.getRelatedTopics()
  },
  methods: {
    async getRelatedTopics() {
      const res = await this.$http.get(THIRD_API.alkTopicRelated.link, {
        params: {
          id: this.topic.id,
          pz: 6
        }
      })
      this.topics = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.topic-view-related-topics-wrapper {
  margin-top: 86px;
  .title {
    font-size: 30px;
    line-height: normal;
    margin-bottom: 40px;
  }
  .swiper-container {
    position: relative;
  }
  .swiper-slide {
    width: auto;
    height: auto;
  }
  .swiper-button-next,
  .swiper-button-prev {
    background-color: #ffffff;
    width: 32px;
    height: 58px;
    line-height: 58px;
    margin-top: -29px;
    background-image: none;
    i {
      font-size: 20px;
      color: #363636;
      font-weight: bold;
      position: absolute;
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
  .swiper-button-next {
    right: 0;
    border-radius: 100px 0 0 100px;
    box-shadow: -4px 0 8px rgba(0, 0, 0, 0.15);
    i {
      left: 10px;
    }
  }
  .swiper-button-prev {
    left: 0;
    border-radius: 0 100px 100px 0;
    box-shadow: 4px 0 8px rgba(0, 0, 0, 0.15);
    i {
      left: 5px;
    }
  }
}
</style>
